import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { IContact } from '../../../models/contact.interface';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IEInvoiceSubscription } from '../models/e-invoice-subscription.interface';

@Component({
  selector: 'upsc-e-invoice-sign-up-form',
  templateUrl: './e-invoice-sign-up-form.component.html',
  styleUrls: ['./e-invoice-sign-up-form.component.scss'],
})
export class EInvoiceSignUpFormComponent implements OnInit, OnChanges {
  @Input() contact: IContact;
  @Output() contactRendered: EventEmitter<IContact> = new EventEmitter<IContact>();
  @Output() formSubmitting: EventEmitter<IEInvoiceSubscription> = new EventEmitter<IEInvoiceSubscription>();

  public formGroup: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder) {
    this.formGroup = this.formBuilder.group({
      customerId: ['', Validators.compose([Validators.required])],
      isSubscribed: [true],
    });
  }

  public ngOnInit() {
  }

  public ngOnChanges(changes: SimpleChanges) {
    this.onContactChanged(changes['contact']);
  }

  private onContactChanged(change: SimpleChange) {
    if (!change || !change.currentValue) {
      return;
    }

    const updatedContact = <IContact>(change.currentValue);
    this.formGroup.controls.customerId.setValue(updatedContact.CustomerId);

    this.contactRendered.emit(updatedContact);
  }

  public onFormSubmit(event, form) {
    event.preventDefault();

    const eInvoiceSubscription = {
      CustomerID: form.customerId,
      IsEInvoice: form.isSubscribed,
    };

    this.formSubmitting.emit(eInvoiceSubscription);
  }
}
